import { schema } from "normalizr";
import EventSchema from "./event";

export default new schema.Array(EventSchema);
